import HubAboutNhsTherapyPage from './HubAboutNhsTherapyPage'

export default HubAboutNhsTherapyPage
